import React, { useEffect } from 'react'
import { Card, Descriptions, Spin, Table, Tag, Empty } from 'antd'
import moment from 'moment'

function View (props) {
  const { match, fetch, data, loading } = props

  useEffect(() => {
    if (match && match.params && match.params.id) {
      fetch(match.params.id)
    }
  }, [match && match.params && match.params.id])

  const record = data || {}
  const asset = record.asset || {}
  const method = record.fuelReadingMethod || {}
  const createdBy = record.createdBy || {}
  const meterReadings = record.meterReadings || []

  const meterColumns = [
    { title: 'Meter', dataIndex: 'meter', render: (m) => (m && m.meterNo) || '-' },
    { title: 'Meter Unit', dataIndex: 'meterType', render: (t) => (t && t.name) || '-' },
    { title: 'Reading', dataIndex: 'reading' },
    { title: 'Calculated', dataIndex: 'calculatedReading' },
    { title: 'Faulty', dataIndex: 'isFaultyMeter', render: (v) => v ? <Tag color='red'>Faulty</Tag> : '-' }
  ]

  return (
    <Spin spinning={loading}>
      <Card className='gx-card-metrics' title={`Fuel Level Reading ${record.readingNo ? `- ${record.readingNo}` : ''}`}>
        <Descriptions bordered column={{ xs: 1, sm: 1, md: 2 }} size='small'>
          <Descriptions.Item label='Reading No'>{record.readingNo || '-'}</Descriptions.Item>
          <Descriptions.Item label='Source'>{record.source || '-'}</Descriptions.Item>
          <Descriptions.Item label='Asset'>
            {asset.assetCode ? `${asset.assetCode}${asset.altName ? ` (${asset.altName})` : ''}${asset.ownerCode ? ` / ${asset.ownerCode}` : ''}` : '-'}
          </Descriptions.Item>
          <Descriptions.Item label='Fuel Reading Method'>{method.name || '-'}</Descriptions.Item>
          <Descriptions.Item label='Fuel Level'>{record.fuelLevel != null ? record.fuelLevel : '-'}</Descriptions.Item>
          <Descriptions.Item label='Reading Date & Time'>
            {record.readingDate ? moment(record.readingDate).format('DD/MM/YYYY HH:mm:ss') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label='Source Voucher'>{record.sourceReference || '-'}</Descriptions.Item>
          <Descriptions.Item label='Recorded By'>{createdBy.name || '-'}</Descriptions.Item>
          <Descriptions.Item label='Created At'>
            {record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss') : '-'}
          </Descriptions.Item>
        </Descriptions>

        <div style={{ marginTop: 20 }}>
          <h3>Meter Readings recorded with this reading</h3>
          {meterReadings.length ? (
            <Table
              rowKey={(r) => r._id}
              columns={meterColumns}
              dataSource={meterReadings}
              size='small'
              pagination={false}
            />
          ) : (
            <Empty description='No meter readings linked to this record' />
          )}
        </div>

        {record.documents && record.documents.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <h3>Attachments</h3>
            {record.documents.map((doc, idx) => (
              <div key={idx} style={{ marginBottom: 6 }}>
                <a href={doc.url} target='_blank' rel='noopener noreferrer'>{doc.name || doc.url}</a>
              </div>
            ))}
          </div>
        )}
      </Card>
    </Spin>
  )
}

export default View
